import LinkEnhance from '@/component/LinkEnhance'
import TGASDK from '@/config/TGASDK'
import React from 'react'
import { useTranslation } from 'react-i18next'

const NavFooter: React.FC<PropType> = () => {
  const { t } = useTranslation()

  return (
    <div className="w-48">
      <div className="px-4 group-hover:visible sm:invisible 2xl:visible">
        {TGASDK.context.appConfig.page.footerEnabled && (
          <>
            <ul className="mb-10 text-sm [&>li]:py-[2px]">
              <li>
                <LinkEnhance href="terms/">{t('footerMenu.terms')}</LinkEnhance>
              </li>
              <li>
                <LinkEnhance href="privacy/">{t('footerMenu.privacy')}</LinkEnhance>
              </li>
              <li>
                <LinkEnhance href="cookies/">{t('footerMenu.cookies')}</LinkEnhance>
              </li>
            </ul>
            <div className="text-xs">© 2016-2025 JUST4FUN</div>
          </>
        )}
      </div>
    </div>
  )
}

interface PropType {}

export default React.memo(NavFooter)
